<div class="p-sub-column-layout01">
  <div class="p-sub-column-layout01__title p-sub-column-layout01__title--has-btn">
    <div class="p-heading-area01">
      <h2 class="p-heading-area01__title c-heading-2" [innerHTML]="'heading.price2' | staticMsg"></h2>
    </div>
    <button id="{{ id }}_payment-detail-btn" class="c-btn-tertiary c-btn-tertiary--xs">
      <span
        class="c-btn-tertiary__text"
        [innerHTML]="'label.details2' | staticMsg"
        (click)="clickPaymentDetails()"
      ></span>
    </button>
  </div>
  <div class="p-sub-column-layout01__body">
    <div class="p-sub-column-layout01__item">
      <dl class="c-flex-list01">
        <div class="c-flex-list01__item c-flex-list01__item--sb c-flex-list01__item--center">
          <dt class="c-flex-list01__title">
            <div>
              <span
                class="c-flex-list01__text-strong p-sub-column-layout01__text-total"
                [innerHTML]="'label.paymentTotalAmount1' | staticMsg"
              ></span>
            </div>
          </dt>
          <dd class="c-flex-list01__contents">
            <div class="c-flex-list01__contents-item">
              <span class="c-amount c-amount--price c-flex-list01__text-strong">
                <span class="c-amount__num c-amount__num--fs24" [innerHTML]="totalPrice | amountFormat"></span>
              </span>
            </div>
          </dd>
        </div>
      </dl>
    </div>
  </div>
</div>
